window.chmSearch = (function() {
    let _chmSearch;

    _chmSearch = function(apiPath) {
        let _this, STATUS;

        STATUS = {
            isRunning: false,
            isCancelled: false,
            reject: null
        };

        _this = {
            search: function(text, params) {
                return new Promise((resolve, reject) => {
                    STATUS.reject = reject;

                    Api.request(apiPath, $.extend({
                        text: text
                    }, params || {})).then(result => {
                        if (STATUS.isCancelled) {
                            return;
                        }
                        resolve(result);
                    }).catch(() => {
                        if (STATUS.isCancelled) {
                            return;
                        }
                        STATUS.reject(false);
                    });
                });
            },
            cancel: function() {
                if (STATUS.isCancelled) {
                    return;
                }

                STATUS.isCancelled = true;
                STATUS.reject(true);
            },
            isRunning: function() {
                return STATUS.isRunning && !STATUS.isCancelled;
            },
            isCancelled: function() {
                return STATUS.isCancelled;
            }
        }

        return _this;
    };

    return _chmSearch;
})();
